import React, { Component, Fragment } from "react";
import { Col, Row } from 'reactstrap';
import { withStyles } from "@material-ui/core/styles";
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import TextField from '@material-ui/core/TextField';

const MedicalRadio = withStyles({
    root: {
        color: '#4CE1B6',
        '&$checked': {
            color: '#4CE1B6',
        },
    },
    checked: {},
})((props) => <Radio color="default" {...props} />);

class Gynecologists extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <Fragment>
                <Row>
                    <Col md={6} xs={12}>
                        <div className="element-question-background">
                            <div className="question-background">
                                <FormControl component="fieldset">
                                    <FormLabel style={{ color: 'black' }} disabled={true}>Ginecoobstétricos</FormLabel>
                                    <RadioGroup
                                        onChange={(e) => {
                                            this.props.handlerGynecologistBackgroundRadio(e.target.value, 'ginecoobstetrico');
                                        }}
                                        row aria-label="position"
                                        id="radio-gynecologists-ginecoobstetrico"
                                        name="radio-gynecologists-ginecoobstetrico"
                                        value={this.props.sectionAilment.gynecologists.ginecoobstetrico.value}>
                                        <FormControlLabel value="Si" control={<MedicalRadio disabled={this.props.stateClinicHistory}/>} label="Si" />
                                        <FormControlLabel value="No" control={<MedicalRadio disabled={this.props.stateClinicHistory} />} label="No" />
                                    </RadioGroup>
                                </FormControl>
                            </div>
                            <div className="answer-background">
                                <TextField
                                    label=""
                                    disabled={this.props.sectionAilment.gynecologists.ginecoobstetrico.value == "No" || this.props.stateClinicHistory == true ? true : false}
                                    value={this.props.sectionAilment.gynecologists.ginecoobstetrico.comentario}
                                    onChange={(e) => {
                                        this.props.handlerGynecologistBackgroundText(e.target.value, 'ginecoobstetrico');
                                    }}
                                    className="medical-material-form__field"
                                    InputLabelProps={{
                                        //style: { color: '#646777' }
                                    }}
                                />
                            </div>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <div className="form">
                        <span className="form__form-group-label" style={{ marginRight: 10, width: 150 }}>Observaciones</span>
                        <div className="form__form-group-field">
                            <textarea
                                id="textarea-observation"
                                value={this.props.sectionAilment.gynecologists.observacion}
                                //disabled={this.props.sectionAilment.surgicals.quirurjico.value == "No"  || this.props.stateClinicHistory == true ? true : false}
                                name="textarea-surgical"
                                onChange={(e) => {
                                    this.props.handlerGynecologistBackgroundObservation(e.target.value, 'observacion');
                                }}
                            >
                            </textarea>
                        </div>
                    </div>
                </Row>
            </Fragment>

        );
    }
}

export default Gynecologists;
